export default "__VITE_ASSET__a9dcbcf7__"